module.exports = __webpack_public_path__ + "Server-Healthy.AzureWebApp.c653a93ff0a6073db645a4981295541a.hashedasset.svg";